export const SET_FIRST_NAME = 'FAMILY_MEMBER_SET_FIRST_NAME';
export const SET_FIRST_NAME_ERRORS = 'FAMILY_MEMBER_SET_FIRST_NAME_ERRORS';

export const SET_LAST_NAME = 'FAMILY_MEMBER_SET_LAST_NAME';
export const SET_LAST_NAME_ERRORS = 'FAMILY_MEMBER_SET_LAST_NAME_ERRORS';

export const SET_EMAIL_ADDRESS = 'FAMILY_MEMBER_SET_EMAIL_ADDRESS';
export const SET_EMAIL_ADDRESS_ERRORS = 'FAMILY_MEMBER_SET_EMAIL_ADDRESS_ERRORS';

export const SET_MOBILE_PHONE = 'FAMILY_MEMBER_SET_MOBILE_PHONE';
export const SET_MOBILE_PHONE_ERRORS = 'FAMILY_MEMBER_SET_MOBILE_PHONE_ERRORS';

export const SET_DATE_OF_BIRTH = 'FAMILY_MEMBER_SET_DATE_OF_BIRTH';
export const SET_DATE_OF_BIRTH_ERRORS = 'FAMILY_MEMBER_SET_DATE_OF_BIRTH_ERRORS';

export const SET_GROUP_ID = 'FAMILY_MEMBER_SET_GROUP_ID';
export const SET_GROUP_ID_ERRORS = 'FAMILY_MEMBER_SET_GROUP_ID_ERRORS';

export const SET_GENDER = 'FAMILY_MEMBER_SET_GENDER';
export const SET_GENDER_ERRORS = 'FAMILY_MEMBER_SET_GENDER_ERRORS';

export const SET_MARITAL_STATUS = 'FAMILY_MEMBER_SET_MARITAL_STATUS';
export const SET_MARITAL_STATUS_ERRORS = 'FAMILY_MEMBER_SET_MARITAL_STATUS_ERRORS';

export const SET_GUEST = 'FAMILY_MEMBER_SET_GUEST';
export const SET_GUEST_ERRORS = 'FAMILY_MEMBER_SET_GUEST_ERRORS';

export const ADD_FAMILY_MEMBER = 'ADD_FAMILY_MEMBER';
export const REMOVE_FAMILY_MEMBER = 'REMOVE_FAMILY_MEMBER';

export const SET_FAMILY_MEMBERS = 'SET_FAMILY_MEMBERS';

export const SET_ERRORS = 'FAMILY_MEMBER_SET_ERRORS';


// WEBPACK FOOTER //
// ./src/actionTypes/familyMembers.js